import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="Concubine x Casual SEX CAMPUS parte 3"
      portada="https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-1.jpg"
 paginas={[
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-1.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-2.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-3.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-4.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-5.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-6.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-7.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-8.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-9.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-10.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-11.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-12.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-13.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-14.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-15.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-16.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-17.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-18.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-19.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-20.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-21.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-22.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-23.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-24.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-25.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-26.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-27.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-28.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-29.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-30.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-31.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-32.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-33.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-34.jpg",
  "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-35.jpg"
]}
      sugeridos={[]}


      info={{
      grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [" "],
etiquetas: ["Ahegao", "Beauty Mark", "Big Breasts", "Blowjob", "Bunny Girl", "Cheating", "Digital", "Glasses", "Inverted Nipples", "Kemonomimi", "Multi-work Series", "Nakadashi", "Netorare", "Prostate Massage", "Schoolgirl Uniform", "Sole Female", "Sole Male", "Stockings"],
    artistas: "Fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "Concubine x Casual SEX CAMPUS parte 3",
  portada: "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-1.jpg",
  reverso: "https://fullcomics18.org/img14/concubine-x-casual-sex-campus3-10.jpg",
   fecha:"2026-05-16",


  info: {
    grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [" "],
etiquetas: ["Ahegao", "Beauty Mark", "Big Breasts", "Blowjob", "Bunny Girl", "Cheating", "Digital", "Glasses", "Inverted Nipples", "Kemonomimi", "Multi-work Series", "Nakadashi", "Netorare", "Prostate Massage", "Schoolgirl Uniform", "Sole Female", "Sole Male", "Stockings"],
    artistas: "Fuetakishi",
  },
};
